import { inject, Injectable } from '@angular/core';
import { Navigation } from 'app/core/navigation/navigation.types';
import { TenantSettingsStore } from 'app/core/tenant-settings/store/tenant-settings.store';
import { UserStore } from 'app/modules/users/store/user.store';
import { User } from 'app/shared/types/user.types';
import { Observable, ReplaySubject, of } from 'rxjs';
import { navigationByRole } from 'app/core/navigation/navigation-data';
import { cloneDeep } from 'lodash-es';

@Injectable({ providedIn: 'root' })
export class NavigationService {
    private _navigation: ReplaySubject<Navigation> = new ReplaySubject<Navigation>(1);
    private _userStore = inject(UserStore);
    private _tenantSettingsStore = inject(TenantSettingsStore);

    get navigation$(): Observable<Navigation> {
        return this._navigation.asObservable();
    }

    get(): Observable<Navigation> {
        const navigation = this._buildNavigation(this._userStore.user());
        this._navigation.next(navigation);
        return of(navigation);
    }

    private _buildNavigation(user: User | null): Navigation {
        const roleBasedNav = user?.role
            ? navigationByRole(user.role, this._tenantSettingsStore.features())
            : [];

        return {
            compact: cloneDeep(roleBasedNav),
            default: cloneDeep(roleBasedNav),
            futuristic: cloneDeep(roleBasedNav),
            horizontal: cloneDeep(roleBasedNav),
            navigationByRole: cloneDeep(roleBasedNav)
        };
    }
}
